import Proxies from 'Components/proxies'
import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import CollapsibleCard from 'Components/collapsibleCard'
import { AttachFile, CloudUpload } from '@material-ui/icons'
import { Button } from 'reactstrap'

const OrderAttachments = props => {
  const [attachments, setAttachments] = useState([])
  const [isUploading, setIsUploading] = useState(false)
  const fileInputRef = useRef(null)

  const createUploadPayload = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = () => {
        resolve({
          name: file.name,
          fileName: file.name,
          content: reader.result
        })
      }

      reader.onerror = () => {
        reject(new Error('Failed to read file'))
      }

      reader.readAsDataURL(file)
    })
  }

  const fetchAttachments = () => {
    Proxies.GET('orders/getOrderAttachments', { OrderID: props.OrderID }).then(responseJSON => {
      if (responseJSON && responseJSON.error) {
        toast.error('Fetching attachments failed', {
          autoClose: 3000
        })
      } else {
        setAttachments(responseJSON)
      }
    })
  }

  const handleDownload = async attachment => {
    Proxies.GET('orders/getAttachmentData', { OrderAttachmentID: attachment.OrderAttachmentID }).then(responseJSON => {
      const a = document.createElement('a')
      a.href = responseJSON.fileData
      a.download = responseJSON.fileName
      a.click()
    })
  }

  const handleFileChange = e => {
    const files = Array.from(e.target.files)
    if (!files.length) return

    setIsUploading(true)

    Promise.all(
      files.map(async file => {
        const uploadFile = await createUploadPayload(file)
        return Proxies.POST('orders/uploadAttachment', {
          OrderID: Number(props.OrderID),
          file: uploadFile
        })
      })
    )
      .then(results => {
        setIsUploading(false)
        e.target.value = ''
        const hasError = results.some(r => !r || r.error)
        if (hasError) {
          toast.error('One or more uploads failed', { autoClose: 3000 })
        } else {
          toast.success(`${files.length > 1 ? files.length + ' files' : 'File'} uploaded`, { autoClose: 3000 })
        }
        fetchAttachments()
      })
      .catch(() => {
        setIsUploading(false)
        e.target.value = ''
        toast.error('One or more uploads failed', { autoClose: 3000 })
      })
  }

  useEffect(() => {
    fetchAttachments()
  }, [])

  if (!(attachments?.length > 0 || !!props.CustomOrder)) {
    return <></>
  }

  return (
    <>
      <input type='file' multiple ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
      <CollapsibleCard
        startOpen={true}
        headerProps={{ style: { display: 'flex', alignItems: 'center' } }}
        header={
          <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flex: 1 }}>
            <strong>Vedhæftede filer</strong>
            {!!props.CustomOrder && (
              <Button
                disabled={isUploading}
                onClick={e => {
                  e.stopPropagation()
                  fileInputRef.current.click()
                }}
              >
                <CloudUpload style={{ fontSize: 16, marginRight: 6 }} />
                {isUploading ? 'Uploader...' : 'Upload'}
              </Button>
            )}
          </span>
        }
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {attachments.toReversed().map(attachment => (
            <div
              key={attachment.OrderAttachmentID}
              style={{
                width: '100%',
                position: 'relative',
                display: 'flex',
                gap: 10,
                cursor: 'pointer'
              }}
              onClick={() => handleDownload(attachment)}
            >
              <AttachFile />
              <div style={{ fontSize: 14, fontWeight: '600' }}>{attachment.fileName}</div>
            </div>
          ))}
        </div>
      </CollapsibleCard>
    </>
  )
}

export default OrderAttachments
